module.exports = __webpack_public_path__ + "assets/img/bug.f34b1328.svg";